/*
 * @format
 */

import React from 'react';

import WatchFace, { anchorsFor } from './WatchFace';
import { DiagramFrame, Label, Leader } from './DiagramParts';

/* The watch's zone screen with its three readouts named. */
const WIDTH = 360;
const HEIGHT = 360;
const CX = 200;
const CY = 170;

const anchors = anchorsFor(CX, CY);

function WatchZoneDiagram() {
  return (
    <DiagramFrame
      width={WIDTH}
      height={HEIGHT}
      description={
        'A watch zone screen. The dial shows the zone name, the current ' +
        'temperature above the target temperature, and the heating mode ' +
        'beneath it.'
      }>
      <WatchFace cx={CX} cy={CY} />

      <Leader from={{ x: 92, y: 100 }} to={anchors.roomTemperature} />
      <Label x={6} y={62} heading={['Current', 'temperature']} />

      <Leader from={{ x: 100, y: 286 }} to={anchors.setpoint} />
      <Label x={6} y={300} heading={['Target', 'temperature']} />

      <Leader from={{ x: 300, y: 286 }} to={anchors.mode} />
      <Label x={WIDTH - 6} y={300} heading={['Heating', 'mode']} anchor="end" />
    </DiagramFrame>
  );
}

export default WatchZoneDiagram;
